import { EmptyStateWithIcon, LoadingPage } from '@idu-nightlife/ui-kit';
import { useManagerSelection } from '../../app/contexts/manager-selection';

const NO_APPS_MESSAGE =
  'There are no apps available to you here. Ask a venue Manager to invite you, or log out and sign in with a different account.';

/**
 * The shell's default entry. ManagerSelectionProvider redirects to the default application once
 * grants settle; when they settle with nothing to open, say so rather than load forever.
 */
export function DefaultAppPage() {
  const { hasNoApps } = useManagerSelection();

  return hasNoApps ? <EmptyStateWithIcon message={NO_APPS_MESSAGE} /> : <LoadingPage />;
}
